export default "__VITE_ASSET__CevEVFBU__"